import { Link } from "react-router-dom";

export const NavItem = ({
  icon,
  label,
  link,
  isLink,
  isMobile,
  closeMenu,
  isDark,
}: {
  label: string;
  icon: React.ReactNode;
  link: string;
  isLink?: boolean;
  isMobile?: boolean;
  closeMenu?: VoidFunction;
  isDark?: boolean;
}) => {
  const handleClick = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    id: string
  ) => {
    if (closeMenu) {
      closeMenu();
    }
    if (isLink) return;

    e.preventDefault();
    const el = document.getElementById(id);

    if (el) {
      const headerOffset = 100;
      const elementPosition = el.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  if (isMobile) {
    return (
      <Link to={link} onClick={(e) => handleClick(e, link.slice(1))}>
        <div className={`flex w-full flex-col p-[2.13vw] border rounded-2xl mb-[2vw] ${isDark ? "border-white/10" : "border-white"}`}>
          <div className="w-full flex items-center justify-between ">
            <div className="flex items-center gap-[3.2vw]">
              <div className={`size-[2vw] max-lg:size-[7.46vw] flex items-center justify-center rounded-lg shadow-custom ${isDark ? "bg-white/10" : "bg-white"}`}>
                {icon}
              </div>
              <span className={`text-[1vw] max-lg:text-[3.73vw] leading-[1.1] ${isDark ? "text-white/80" : "text-black"}`}>
                {label}
              </span>
            </div>
          </div>
        </div>
      </Link>
    );
  }
  return (
    <li>
      <Link target="_blanc" to={link} onClick={(e) => handleClick(e, link.slice(1))}>
        <div className="navigation-link py-[0.65vw] pr-[1.1vw] pl-[0.65vw] outline-none flex items-center gap-[0.8vw] rounded-2xl">
          <div className={`size-[2vw] flex items-center justify-center rounded-lg shadow-custom ${isDark ? "bg-white/10" : "bg-white"}`}>
            <div>{icon}</div>
          </div>
          <span className={`text-[1vw] leading-[1.1] font-luxora-regular ${isDark ? "text-white/80" : "text-black"}`}>
            {label}
          </span>
        </div>
      </Link>
    </li>
  );
};
